module.exports = __webpack_public_path__ + "static/media/image_65.2272d063.png";